export const navigation = [
  {
    title: 'Assignment',
    url: '/assignments'
  }
];